import { NavLink, Outlet } from "react-router-dom";
import styles from "./links.module.scss";

export function LinksReportLayout() {
    return (
        <>
            <ul className={styles.tabs}>
                <li>
                    <NavLink to="./placements">Summary</NavLink>
                </li>
                <li>
                    <NavLink to="./countries">Countries</NavLink>
                </li>
                <li>
                    <NavLink to="./download-clients">Download Clients</NavLink>
                </li>
                <li>
                    <NavLink to="./downloaded-episodes">
                        Downloaded Episodes
                    </NavLink>
                </li>
            </ul>

            <Outlet />
        </>
    );
}
